import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNotificationsSnackbar } from '@/components/snackbar/NotificationsSnackbarContext';
import { WorkForceConnectRequest } from '@/models/payment';
import { useAppDispatch } from '@/lib/hooks';
import { setLoader } from '@/lib/slices/globalLoaderSlice';
import { usePaymentsMutations } from '@/services/paymentsMutations';
import { Box, GridLegacy as Grid } from '@mui/material';
import { InputText } from '@/components/shared/InputText';
import {
    SecondaryButtonStyle,
    PrimaryButtonStyle
} from '@/pages/company/common/IntegrationDialog';

interface WorkForceConnectProps {
    onClose?: () => void;
    onSaveSuccess: any;
}

export const WorkForceConnect = (props: WorkForceConnectProps) => {
    const { t } = useTranslation();
    const [workForceData, setWorkForceData] = useState<WorkForceConnectRequest>(
        {} as any
    );
    const { setAlert } = useNotificationsSnackbar();

    const { connectWorkForce } = usePaymentsMutations();

    const dispatch = useAppDispatch();

    const onClick = () => {
        connectWorkForce.mutate({ ...workForceData });
    };

    useEffect(() => {
        if (connectWorkForce.isSuccess) {
            props.onSaveSuccess();
        }
    }, [connectWorkForce.isSuccess]);

    useEffect(() => {
        if (connectWorkForce.isError) {
            setAlert('Connection failed', 'error');
        }
    }, [connectWorkForce.isError]);

    useEffect(() => {
        dispatch(setLoader(connectWorkForce.isPending));
    }, [connectWorkForce.isPending]);

    return (
        <>
            <Box width={'100%'} margin={'20px 0 10px'}>
                <InputText
                    value={workForceData?.username ?? ''}
                    label={t('workforce_username')}
                    onChange={(e) => {
                        setWorkForceData({
                            ...workForceData,
                            username: e.target.value
                        });
                    }}
                    spacing="10px 0"
                />

                <InputText
                    type="password"
                    value={workForceData?.password ?? ''}
                    label={t('workforce_password')}
                    onChange={(e) => {
                        setWorkForceData({
                            ...workForceData,
                            password: e.target.value
                        });
                    }}
                    spacing="10px 0"
                />

                <InputText
                    value={workForceData?.tenant ?? ''}
                    label={t('workforce_tenant')}
                    onChange={(e) => {
                        setWorkForceData({
                            ...workForceData,
                            tenant: e.target.value
                        });
                    }}
                    spacing="10px 0"
                />
            </Box>

            <Grid m={'20px 0'} container justifyContent={'space-around'}>
                <SecondaryButtonStyle
                    onClick={props?.onClose}
                    sx={{ width: '170px' }}
                >
                    {t('cancel')}
                </SecondaryButtonStyle>

                <PrimaryButtonStyle
                    onClick={onClick}
                    sx={{ width: '170px' }}
                    disabled={
                        !workForceData.username ||
                        !workForceData.password ||
                        !workForceData.tenant
                    }
                >
                    {t('connect')}
                </PrimaryButtonStyle>
            </Grid>
        </>
    );
};
